import _get from 'lodash/get';
import { TaskKindEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

export default function isScheduleMessageVisible(values: Values): boolean {
  const taskKind = _get(values, `${FieldNames.taskKind}.value`);
  if (taskKind === TaskKindEnum.OnDemand) return true;
  const deadlineAt = _get(values, FieldNames.deadlineAt);
  const recurringRuleEnabled = _get(
    values,
    FieldNames.recurringRuleEnabled,
    false,
  );
  return !!deadlineAt || !!recurringRuleEnabled;
}
